import React from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import ToastHeader from "react-bootstrap/ToastHeader";
import ToastBody from "react-bootstrap/ToastBody";
import Spinner from "react-bootstrap/Spinner";

export const WebinarRegistrations = (props) => {
  return (
    <Container fluid={true} className="position-relative">
      <ToastContainer position="top-end" className="pt-2 pe-md-1">
        <Toast show={props.loading} bg="info">
          <ToastBody>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Getting all registrations
          </ToastBody>
        </Toast>
        <Toast
          show={props.error !== null}
          bg="danger"
          onClose={props.dismissError}
        >
          <ToastHeader closeButton={true}>
            <strong className="me-auto">Fetch error</strong>
          </ToastHeader>
          <ToastBody>{props.error}</ToastBody>
        </Toast>
      </ToastContainer>
      <Table hover={true} striped={true} bordered={true} responsive="sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Webinar</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Age</th>
          </tr>
        </thead>
        <tbody>
          {props.registrations.map((r, index) => (
            <tr key={index}>
              <td>{r?.user?.first_name + " " + r?.user?.last_name}</td>
              <td>{r?.webinar?.title}</td>
              <td>{r?.user?.email_id}</td>
              <td>{r?.phone_number}</td>
              <td>{r?.age}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};
